import React from "react";
import headingImg from "../../assets/img/heading-img.png";
import "./AboutUs.css";
import bannerBg from "../../assets/img/bannr-img.jpg";
import circleImg from "../../assets/img/logo.png";
import textCircleImg from "../../assets/img/text-circle.png";
import history1Img from "../../assets/img/history1.jpg";
import history2Img from "../../assets/img/history2.jpg";
import islamicScholar1 from "../../assets/img/islamic-scholars-1.jpg";
import islamicScholar2 from "../../assets/img/islamic-scholars-2.jpg";
import islamicScholar3 from "../../assets/img/islamic-scholars-3.jpg";
import islamicScholar4 from "../../assets/img/islamic-scholars-4.jpg";
import { NavLink } from "react-router-dom";

const AboutUs = () => {
  return (
    <div>
      <section
        className="bannr-section"
        style={{
          backgroundImage: `url(${bannerBg})`,
        }}
      >
        <div className="container">
          <div className="bannr-text">
            <img src={headingImg} alt="icon" />
            <h2>About</h2>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <NavLink to="/">Home</NavLink>
              </li>
              <li className="breadcrumb-item" aria-current="page">
                About
              </li>
            </ol>
          </div>
        </div>
      </section>
      <section className="gap position-relative">
        <div className="container">
          <div className="heading">
            <img src={headingImg} alt="icon" />
            <h2>Know The History of Mashjid Ar-Rahman</h2>
          </div>
          <div className="row">
            <div className="col-lg-5">
              <div className="islamic-history">
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscsed do eiusmod
                  tempor incididunt ut labore etedum dolor sit a ad minim
                  veniam, quis nostr incididunt ut laborcitationn tempor
                  incididunt ut labore um dolor sit amet, consectetur adipiscsed
                  do eiu agna a liqua. Ut enim ad minim veniam, quis nostr
                  incididunt ut laborcitation.
                </p>
                <ul className="list">
                  <li>Astonishing Facilities</li>
                  <li>Helping CommunitiesLeads </li>
                  <li>Charity EventsSchooling Children</li>
                  <li>Feeding Hungry People</li>
                </ul>
                <a href="#" className="btn">
                  Read Our History
                </a>
              </div>
            </div>
            <div className="col-lg-7">
              <div className="row align-items-end">
                <div className="col-lg-5 col-6">
                  <div className="circle-text circle-logo-div">
                    <img
                      src={textCircleImg}
                      className="circle-text-img"
                      alt="circle-img"
                    />
                    <figure className="circle-img">
                      <img src={circleImg} alt="circle-img" />
                    </figure>
                  </div>
                  <div className="real-history-book hoverimg history-img-1">
                    <figure>
                      <img src={history1Img} alt="img" />
                    </figure>
                  </div>
                </div>
                <div className="col-lg-7 col-6">
                  <div className="real-history-book two hoverimg history-img-2">
                    <figure>
                      <img src={history2Img} alt="real-history-boy" />
                    </figure>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
